import { authAxios } from "@/api";
import { API_VER, ROOT_URL } from "@/setup/constants"

const API_CONTROLLER = "ward";

export class WardApi {
    static getWardList(wardId, filterInfo){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/contacts`;
        return authAxios.post(url, filterInfo);
    }

    static getWard(wardId){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/detail`;
        return authAxios.get(url);
    }

    static getWardOrganizations(wardId){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/organizations`;
        return authAxios.get(url);
    }

    static searchWardOrganizations(wardId, pagingInfo){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/organizations`;
        return authAxios.post(url, pagingInfo);
    }

    static getWardOrganization(wardId, orgCode){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/organization/${orgCode}`;
        return authAxios.get(url);
    }

    static getWardAccountBalance(wardId) {
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/account-balance`;
        return authAxios.get(url)
    }

    static updateWardOrganization(wardId, orgCode, orgInfo){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/organization/${orgCode}`;
        return authAxios.put(url, orgInfo);
    }

    static createWardOrganization(wardId, orgInfo) {
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/organization/create`;
        return authAxios.post(url, orgInfo);
    }

    static getWardDetail(wardId){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/detail`;
        return authAxios.get(url);
    }

    static updateWard(wardId, wardInfo){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/detail`;
        return authAxios.put(url, wardInfo);
    }

    static getWardContact(wardId, contactId){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/contact/${contactId}`;
        return authAxios.get(url);
    }

    static filterWardOrganization(wardId, filterInfo){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/contacts/org`;
        return authAxios.post(url,filterInfo);
    }

    static updateWardContact(wardId, contactId, contactInfo){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/contact/${contactId}`;
        return authAxios.put(url, contactInfo);
    }

    static createWardContact(wardId, contactInfo){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/contact/create`;
        return authAxios.post(url, contactInfo);
    }

    static deleteWardContact(wardId, contactId){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/contact/${contactId}`;
        return authAxios.delete(url);
    }

    static searchContactNotes(wardId, contactId, PagingInfo){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/contact/${contactId}/notes`;
        return authAxios.post(url, PagingInfo);
    }

    static createContactNote(wardId, contactId, NoteInfo) {
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/contact/${contactId}/create-note`;
        return authAxios.post(url, NoteInfo);

    }

    static sendNotificationText(wardId, notificationMessage){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/message/create`;
        return authAxios.post(url, notificationMessage);
    }

    static uploadContactSpreadsheet(wardId, bulkContactUpload){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/contact-import`;
        return authAxios.post(url, bulkContactUpload);
    }

    static searchImportRequests(wardId, PagingInfo) {
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/contact-import-list`;
        return authAxios.post(url, PagingInfo);
    }

    static searchImportRequestsContacts(wardId, importRequestId, PagingInfo) {
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/bulk-contact-list/${importRequestId}`;
        return authAxios.post(url, PagingInfo);
    }

    static getImportRequest(wardId, importRequestId)
    {
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/contact-import/${importRequestId}`;
        return authAxios.get(url);
    }

    static performImportRequest(wardId, importRequestId)
    {
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/perform-import/${importRequestId}`;
        return authAxios.get(url);
    }

    static performingBulkSmsRequest(wardId, importRequestId)
    {
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/contact-import-consent/${importRequestId}`;
        return authAxios.get(url);
    }

    static fetchCarriers(wardId)
    {
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/contact-carrier-fetch`;
        return authAxios.get(url);
    }

    static getWardUserDetail(wardId, username){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/${username}`;
        return authAxios.get(url);
    }

    static updateWardUserDetail(wardId, username, userData){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/${username}`;
        return authAxios.put(url, userData);
    }

    static getWardFrontEndSettings(wardId) {
        const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/front-end-settings`;
        return authAxios.get(url);
    }


}
